module.exports = __webpack_public_path__ + "static/media/back-desctados-escudo.07a3138b.png";